let lastImageData: null | ImageData = null

export function noSameFilter(ctx: CanvasRenderingContext2D) {
  const curImageData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height)
  if (!lastImageData) {
    lastImageData = curImageData
    return true
  }
  const isSame = isSameImageData(lastImageData, curImageData)
  lastImageData = curImageData
  return !isSame
}

export function clearSameFilter() {
  lastImageData = null
}

export function toGrayFilter(ctx: CanvasRenderingContext2D) {
  const imageData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height)

  for (let i = 0; i < imageData.data.length; i += 4) {
    const r = imageData.data[i]
    const g = imageData.data[i + 1]
    const b = imageData.data[i + 2]

    const gray = parseInt(`${(r + g + b ) / 3}`, 10)
    imageData.data[i] = gray
    imageData.data[i + 1] = gray
    imageData.data[i + 2] = gray
  }

  ctx.putImageData(imageData, 0, 0)

  return true
}

export function noEmptyFilter(ctx: CanvasRenderingContext2D) {
  const imageData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height)
  let alpha = 0
  for (let i = 0; i < imageData.data.length; i += 4) {
    alpha = imageData.data[i + 3]
  }
  const isEmpty = alpha === 0
  return !isEmpty
}

function isSameImageData(a: ImageData, b: ImageData) {
  if (a.data.length !== b.data.length) {
    return false
  }
  const max = a.data.length
  for (let i = 0; i < max; i++) {
    if (a.data[i] !== b.data[i]) {
      return false
    }
  }
  return true
}
